import { useState, useCallback } from 'react';
import type React from 'react';
import { emailPattern } from '../../../Donee/components/common/constants';

export const useRecoveryStep = (
    onRecoverySubmit: (email: string) => void,
    initialEmail: string,
) => {
    const [email, setEmail] = useState(initialEmail);
    const [validationError, setValidationError] = useState('');

    const onEmailChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(e.target.value);
            setValidationError('');
        },
        [],
    );

    const onSubmit = useCallback(() => {
        if (!email) return;
        if (!emailPattern.test(email)) {
            setValidationError('Please enter a valid email address');
            return;
        }
        onRecoverySubmit(email);
    }, [email, onRecoverySubmit]);

    return { email, validationError, onEmailChange, onSubmit };
};
